export const tr = {
    translation: {
        b: {
            cancel: 'İptal',
            confirm: 'Onayla',
            send: 'Gönder',
            done: 'Bitti',
            close: 'Kapat',
            clear: 'Temizle',
            copy_link: 'Bağlantıyı kopyala',
            export: 'Dışa aktar',
            delete: 'Sil',
            delete_confirm: 'Silmeyi onayla',
            duplicate: 'Çoğalt',
            share: 'Paylaş',
            sign_in: 'Giriş yap',
            sign_up: 'Kayıt ol',
            email_address: 'E-posta adresi',
            yes: 'Evet',
            no: 'Hayır',
            back: 'Geri',
            upgrade: 'Yükselt',
            remove: 'Kaldır',
            restore: 'Geri yükle',
            archive: 'Arşivle',
            rename: 'Yeniden adlandır',
            leave: 'Ayrıl',
            import: 'İçe aktar',
            continue: 'Devam et',
            settings: 'Ayarlar',
            log_out: 'Çıkış yap',
            invite: 'Davet et',
            invited: 'Davet edildi',
        },
        roles: {
            view: 'Görüntüleyici',
            comment: 'Yorumcu',
            edit: 'Düzenleyici',
            admin: 'Yönetici',
            owner: 'Sahip',
            member: 'Üye',
            remove: 'Kaldır',
            more_roles: 'Daha fazla rol...',
            change_role: 'Rolü değiştir...',
            remove_access: 'Erişimi kaldır...',
            remove_invite: 'Daveti kaldır...',
        },
        db_engine: {
            basic: 'Temel SQL',
            general: 'Genel SQL',
        },
        socket_status: {
            reconnecting: 'Yeniden bağlanıyor...',
            offline: 'Çevrimdışısınız. Yeniden bağlanıyor...',
        },
        loader: {
            diagram: 'Diyagram yükleniyor...',
        },
        m_languages: {
            title: 'Diller',
            subtitle: 'Bir dil seçin'
        },
        m_feedback: {
            feature: {
                name: 'Özellik isteği',
                desc: 'İhtiyacınız olan bir özellik eksik mi? Bize bildirin — fikirleriniz değerli'
            },
            feedback: {
                name: 'Geri bildiriminizi paylaşın',
                desc: 'Ne düşündüğünüzü duymayı çok isteriz'
            },
            support: {
                name: 'Destek',
                desc: 'Bir şey çalışmıyor mu? Bize bildirin — hızlıca çözelim',
            },
            bug: {
                name: 'Sorun bildir',
                desc: 'Bir şeyler tam olarak doğru değil mi? Bildirin — hızlıca ele alalım',
            },
            integration: {
                name: 'Entegrasyon iste',
                desc: 'Geri bildiriminiz bizim için çok değerli — kısa bir not bırakın',
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Öneriniz için teşekkürler!',
                desc: 'Düşüncelerinizi paylaşmak için zaman ayırmanıza gerçekten minnettarız — bu, iyileştirmemize yardımcı olur.'
            },
            feedback: {
                name: 'Geri bildiriminiz için teşekkürler!',
                desc: 'Düşüncelerinizi paylaşmak için zaman ayırmanıza gerçekten minnettarız — bu, iyileştirmemize yardımcı olur.'
            },
            support: {
                name: 'Bizimle iletişime geçtiğiniz için teşekkürler!',
                desc: 'Destek ekibimizle iletişime geçtiğiniz için teşekkürler — talebinizi inceleyip en kısa sürede yanıt vereceğiz.',
            },
            bug: {
                name: 'Bildiriminiz için teşekkürler!',
                desc: 'Bunu bildirdiğiniz için teşekkürler — bu, sorunları daha hızlı çözmemize ve deneyimi sürekli iyileştirmemize yardımcı oluyor.',
            },
            contact: {
                name: 'Bizimle iletişime geçtiğiniz için teşekkürler!',
                desc: 'Mesajınızı aldık ve en kısa sürede size geri döneceğiz.',
            },
            invite_people: {
                name: 'Davet başarıyla gönderildi!',
                desc: 'Bunu duyurduğunuz için teşekkürler — onları aramızda görmek için sabırsızlanıyoruz.',
            },
            integration: {
                name: 'Öneriniz için teşekkürler!',
                desc: 'Düşüncelerinizi paylaşmak için zaman ayırmanıza gerçekten minnettarız — bu, iyileştirmemize yardımcı olur.',
            },
        },
        m_diagram_details: {
            name_place: 'Proje adını girin',
            desc_place: 'Proje açıklamasını girin'
        },
        m_quick_share: {
            title: 'Hızlı paylaşım',
            subtitle: '(Bağlantı ile)'
        },
        m_export_img: {
            title: 'Görseli dışa aktar'
        },
        search_menu: {
            placeholder: 'Tablo, sütun, tür ara...',
            hint: '',
            no_results: 'Sonuç yok',
            quick_results: 'Hızlı sonuçlar:',
            untitled: 'adsız',
            command_tag: 'komut',
            section_tables: 'Tablolar',
            section_columns: 'Sütunlar',
            section_canvas: 'Çalışma alanı',
            section_export: 'Dışa aktar',
            section_preferences: 'Tercihler',
            section_settings: 'Ayarlar',
            type_table: 'tablo',
            type_note: 'not',
            cmd_new_table: 'Yeni tablo oluştur...',
            cmd_new_note: 'Yeni not oluştur...',
            cmd_new_line: 'Yeni çizgi oluştur...',
            cmd_new_area: 'Yeni alan oluştur...',
            cmd_export_image: 'Görseli dışa aktar...',
            cmd_export_sql: 'SQL kodunu dışa aktar...',
            cmd_grid_style: 'Izgara görünümünü değiştir...',
        },
        canvas_table: {
            more_column: 'sütun daha',
            more_columns: 'sütun daha',
            tooltip_table: 'Tablo',
            tooltip_indexes: 'Dizinler',
            tooltip_enum: 'Enum',
            tooltip_default: 'Varsayılan',
            tooltip_generated: 'Oluşturulan',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: '{{db_engine}} kodunu dışa aktar',
            download_file: 'Dosyayı indir',
            copy_code: 'Kodu kopyala'
        },
        m_sign_in_remind: {
            title: 'DB Design’ı denediğiniz için teşekkürler',
            subtitle: 'Tablo sayısı sınırını artırmak, diyagramları kaydetmek ve daha fazla özelliğin kilidini açmak için giriş yapın veya kayıt olun.'
        },
        m_sign_in_restrict: {
            title: 'Uygulamada daha fazlasını yapmak için giriş yapın',
            subtitle: 'Tablo sınırlarını artırmak, diyagramları kaydetmek ve daha fazla özelliğin kilidini açmak için giriş yapın veya kayıt olun.'
        },
        m_new_diagram: {
            title: 'Yeni diyagram',
            subtitle: 'Bir veritabanı motoru seçin',
            open_diagram: 'Diyagramı aç',
            create_diagram: 'Diyagram oluştur',
            no_workspace: 'Bir diyagram başlatmak için önce bir çalışma alanı oluşturun.',
            build_something_new: 'Yeni bir şey oluşturalım',
            create_diagram_section: 'Diyagram oluştur',
            clone_template_btn: 'Şablonu çoğalt',
        },
        m_diagram_name: {
            enter_new_name: 'Yeni bir diyagram adı girin',
        },
        m_diagram_clone: {
            header: 'Diyagramı çoğalt',
            copy_of_title: '{{title}} kopyası',
        },
        m_diagram_rename: {
            header: 'Diyagramı yeniden adlandır',
        },
        m_template_clone: {
            header: 'Şablondan bir diyagram oluştur',
        },
        m_diagram_delete: {
            header: 'Diyagramı sil',
            desc_prefix: 'Silinecek: ',
        },
        m_diagram_archive: {
            header: 'Diyagramı arşivle',
            desc_prefix: 'Arşivlenecek: ',
        },
        m_diagram_restore: {
            header: 'Diyagramı geri yükle',
            desc_prefix: 'Geri yüklenecek: ',
        },
        m_diagram_import: {
            sql_name: 'SQL kodunu içe aktar',
            dbml_name: 'DBML kodunu içe aktar',
            // NOTE: en.js flags this placeholder copy as mismatched content (reads like
            // feedback-modal copy, not an SQL/DBML paste prompt). Kept verbatim in
            // translation since fixing the copy is a product call, not a translation one.
            placeholder: 'Düşüncelerinizi duymak isteriz!',
        },
        m_diagram_not_found: {
            header: 'Diyagram bulunamadı',
            desc: 'Aradığınız diyagramı bulamadık.',
            back_to_app: 'Uygulamaya dön',
        },
        m_diagram_share: {
            header: 'Diyagramı paylaş – {{title}}',
            owner_only_invite: 'Yalnızca sahip yeni üyeler davet edebilir',
            invited_to_workspace: 'Çalışma alanına davet edildi',
            you: 'siz',
            email_placeholder: 'E-posta girin',
            email_already_in_list: 'e-posta zaten listede',
            will_be_invited_to_workspace: 'çalışma alanına davet edilecek',
        },
        m_invite_people: {
            header: 'Çalışma alanına davet et',
        },
        m_invite_revoke: {
            header: 'Daveti kaldır',
            desc_prefix: 'Şunun davetini kaldır: ',
            desc_suffix: 'Davet artık geçerli olmayacak.',
        },
        m_member_remove: {
            header: 'Üyeyi kaldır',
            desc_prefix: 'Şu kişi bu çalışma alanından kaldırılsın mı: ',
            desc_suffix: '? Erişimini kaybedecek.',
        },
        m_template_details: {
            preview: 'Önizleme',
            use_template: 'Şablonu kullan',
        },
        m_workspace_create: {
            header: 'Yeni bir çalışma alanı oluştur',
            name_label: 'Ad',
            setup_config_label: 'Kurulum yapılandırması',
            setup_config_value: 'Boş çalışma alanı',
            template_structure_label: 'Şablon/Yapı',
            template_structure_value: 'Yapıyı önceden yükle',
            placeholder: 'Çalışma alanı adını girin',
            create_button: 'Çalışma alanı oluştur',
            creating: 'Çalışma alanınız oluşturuluyor...',
        },
        m_workspace_delete: {
            header: 'Çalışma alanını sil',
            desc_prefix: 'Kalıcı olarak silinecek: ',
            confirm_prefix: 'Onaylamak için ',
            confirm_suffix: ' yazın.',
        },
        m_workspace_leave: {
            header: 'Çalışma alanından ayrıl',
            desc_prefix: 'Bu, sizi şuradan kaldıracak: ',
            desc_suffix: '. Yeniden katılmak için tekrar davet edilmeniz gerekecek.',
        },
        m_workspace_menu: {
            manage_members: 'Üyeleri yönet',
            switch_workspace: 'Çalışma alanını değiştir',
            workspaces_label: 'Çalışma alanları',
            create_workspace: 'Çalışma alanı oluştur...',
            switching: 'Değiştiriliyor',
        },
        m_profile_menu: {
            profile: 'Profil',
            onboarding: 'Başlangıç',
        },
        m_pricing_limit: {
            admin_roles: { title: 'İş birliğinizi bir üst seviyeye taşıyın', description: 'Yönetici, Düzenleyici, Yorumcu, Görüntüleyici gibi daha fazla paylaşım rolünün kilidini açmak için yükseltin.' },
            workspaces: { title: 'Hızla büyüyorsunuz!', description: 'Projeleriniz ve ekipleriniz için daha fazla çalışma alanı oluşturmak ve yönetmek üzere yükseltin.' },
            workspaces_canvas: { title: 'Çalışma alanlarınızı genişletin', description: 'Projeleriniz ve ekipleriniz için daha fazla çalışma alanı oluşturmak ve yönetmek üzere yükseltin.' },
            members: { title: 'Büyük ölçekte iş birliği yapın', description: 'Çalışma alanınıza daha fazla üye katmak ve daha etkili iş birliği yapmak için yükseltin.' },
            diagrams: { title: 'Hızla büyüyorsunuz!', description: 'Daha fazla diyagram oluşturmak ve projelerinizi güvenle büyütmek için yükseltin.' },
            tables: { title: 'Sınırsız oluşturun', description: 'Daha fazla tablo eklemek ve daha büyük, daha ayrıntılı diyagramlar oluşturmaya devam etmek için yükseltin.' },
            columns: { title: 'Sınırsız oluşturun', description: 'Daha fazla sütun eklemek ve daha büyük, daha ayrıntılı diyagramlar oluşturmaya devam etmek için yükseltin.' },
            notes: { title: 'Sınırsız oluşturun', description: 'Daha fazla not eklemek ve daha büyük, daha ayrıntılı diyagramlar oluşturmaya devam etmek için yükseltin.' },
            areas: { title: 'Sınırsız oluşturun', description: 'Daha fazla alan eklemek ve daha büyük, daha ayrıntılı diyagramlar oluşturmaya devam etmek için yükseltin.' },
            pens: { title: 'Sınırsız oluşturun', description: 'Daha fazla çizim eklemek ve daha büyük, daha ayrıntılı diyagramlar oluşturmaya devam etmek için yükseltin.' },
            default_title: 'İş birliğinizi bir üst seviyeye taşıyın',
            default_title_canvas: 'Performansınızı artırın',
        },
        m_pricing_plans: {
            title: 'Planınızı yükseltin',
            subtitle: 'Planınızı daha sonra her zaman yükseltebilir veya düşürebilirsiniz',
            monthly: 'Aylık',
            annually: 'Yıllık',
            billed_annually: 'Yıllık faturalandırma',
            billed_monthly: 'Aylık faturalandırma',
            free_for_everyone: 'Herkes için ücretsiz',
            current_plan: 'Mevcut plan',
            will_be_available_soon: 'Yakında kullanıma sunulacak',
            price_period_user_month: '/kullanıcı/ay',
            plan_free: {
                name: 'Ücretsiz',
                button: 'Planı değiştir',
                feature_realtime: 'Gerçek zamanlı iş birliği',
                feature_members: '4 üye / çalışma alanı',
                feature_diagrams: '4 diyagram / çalışma alanı',
                feature_tables: '40 tablo / diyagram',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Tüm Ücretsiz özellikleri +',
                feature_members: 'Sınırsız üye',
                feature_diagrams: 'Sınırsız diyagram',
                feature_tables: 'Sınırsız tablo',
                feature_history: 'Sürüm geçmişi',
                feature_admin_roles: 'Yönetici rolleri',
            },
        },
        sidebar: {
            new: 'Yeni',
            pinned_diagrams: 'Sabitlenmiş diyagramlar',
            pin_hint: 'Burada görmek için diyagramları sabitleyin',
            expand_sidebar: 'Kenar çubuğunu genişlet',
            home_aria: 'DB Design ana sayfası',
            open_menu: 'Menüyü aç',
            close_menu: 'Menüyü kapat',
            sidebar_menu_aria: 'Kenar çubuğu menüsü',
            plan_suffix: 'plan',
            diagram_options: 'Diyagram seçenekleri',
            pin: 'Sabitle',
            unpin: 'Sabitlemeyi kaldır',
            edit_details: 'Ayrıntıları düzenle',
            see_details: 'Ayrıntıları gör',
            invite_people: 'Kişileri davet et',
            collapse_sidebar: 'Kenar çubuğunu daralt',
            close_sidebar: 'Kenar çubuğunu kapat',
            open_sidebar: 'Kenar çubuğunu aç',
            open_new_tab: 'Yeni sekmede aç',
        },
        focus_controls: {
            show_top: 'Üst kontrolleri göster',
            hide_top: 'Üst kontrolleri gizle',
            show_left: 'Sol kontrolleri göster',
            hide_left: 'Sol kontrolleri gizle',
        },
        m_keyboard_shortcuts: {
            title: 'Klavye kısayolları',
            general: {
                title1: 'Genel',
                title2: '',
                items: {
                    new_diagram: 'Diyagram oluştur',
                    new_chat: 'Yeni sohbet',
                    search: 'Hızlı işlemler veya arama',
                    preferences: 'Tercihler',
                    settings: 'Ayarlar',
                    keyboard_shortcuts: 'Klavye kısayolları',
                    toggle_sidebar: 'Kenar çubuğunu aç/kapat',
                    toggle_theme: 'Temayı değiştir',
                },
            },
            ctrl_left: {
                title1: 'Kontroller',
                title2: '(Sol)',
                items: {
                    mouse_sel: 'Fare seçimi / El modu',
                    table: 'Tablo',
                    line: 'Çizgi',
                    area: 'Alan',
                    note: 'Not',
                    comment: 'Yorum',
                    pen: 'Kalem',
                    undo: 'Geri al',
                    redo: 'Yeniden yap'
                }
            },
            ctrl_top_left: {
                title1: 'Kontroller',
                title2: '(Sol üst)',
                items: {
                    export_img: 'Görseli dışa aktar',
                    search: 'Ara',
                    editor_panel: 'Düzenleyici paneli',
                    zoom_to_fit: 'Ekrana sığdır',
                }
            },
            ctrl_bottom_right: {
                title1: 'Kontroller',
                title2: '(Sağ alt)',
                items: {
                    minimap: 'Mini harita',
                    full_screen: 'Tam ekran',
                    zoom_in: 'Yakınlaştır',
                    zoom_out: 'Uzaklaştır',
                    zoom_100: 'Zoom %100'
                }
            },
            ctx_tab: {
                title1: 'Bağlam menüsü',
                title2: '(Tablo)',
                items: {
                    dupl_tab: 'Tabloyu çoğalt',
                    del_tab: 'Tabloyu sil'
                }
            },
            ctx_del_tab: {
                title1: 'Bağlam menüsü',
                title2: '(Tabloyu sil)',
                items: {
                    yes: 'Evet',
                    no: 'Hayır'
                }
            },
            ctx_tab_col: {
                title1: 'Bağlam menüsü',
                title2: '(Sütunu)', // Tablo sütunu
                items: {
                    add_col_below: 'Alta sütun ekle',
                    focus_col_above: 'Odağı üstteki sütununa taşı',
                    focus_col_below: 'Odağı alttaki sütununa taşı',
                    move_col_up: 'Sütunu yukarı taşı',
                    move_col_down: 'Sütunu aşağı taşı',
                    dupl_col: 'Sütunu çoğalt',
                    del_col: 'Sütunu sil'
                }
            },
            ctx_line: {
                title1: 'Bağlam menüsü',
                title2: '(Çizgi)',
                items: {
                    del_line: 'Çizgiyi sil'
                }
            },
            ctx_area: {
                title1: 'Bağlam menüsü',
                title2: '(Alan)',
                items: {
                    dupl_area: 'Alanı çoğalt',
                    del_area: 'Alanı sil'
                }
            },
            ctx_multi: {
                title1: 'Bağlam menüsü',
                title2: '(Çoklu seçim)',
                items: {
                    select_all: 'Tüm öğeleri seç',
                    create_area_for_select_els: 'Seçili öğeler için alan oluştur',
                    dupl_select_els: 'Seçili öğeleri çoğalt',
                    del_select_els: 'Seçili öğeleri sil'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Fare seçimi',
                table: 'Tablo',
                line: 'Çizgi',
                area: 'Alan',
                note: 'Not',
                comment: 'Yorum',
                pen: 'Kalem',
                undo: 'Geri al',
                redo: 'Yeniden yap'
            },
            ctrl_top_left: {
                home: 'Ana sayfa',
                name: 'Diyagram bilgileri',
                editor: 'Düzenleyici',
                search: 'Arama',
                export: 'Dışa aktarma seçenekleri',
                view_mode: 'Görünüm modu',
                zoom_to_fit: 'Ekrana sığdır',
                grid: 'Izgara görünümü',
                history: 'Geçmiş',
                main_menu: 'Ana menü',
                new_diagram: 'Yeni diyagram',
            },
            ctrl_top_right: {
                feature_req: 'Özellik isteği',
                feedback: 'Geri bildirim gönder',
                sign_in: 'Giriş yap',
                quick_share: 'Hızlı paylaşım'
            },
            ctrl_bottom_right: {
                full_screen: 'Tam ekran',
                minimap: 'Mini harita',
                zoom_out: 'Uzaklaştır',
                zoom_100: 'Zoom %100',
                zoom_in: 'Yakınlaştır',
                info: 'Bilgi ve kaynaklar'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Varsayılan',
                        blue: 'Mavi',
                        green: 'Yeşil',
                        red: 'Kırmızı',
                        purple: 'Mor',
                        violet: 'Menekşe'
                    },
                    borders: {
                        none: 'Yok',
                        solid: 'Düz',
                        dashed: 'Kesik çizgi',
                        dotted: 'Noktalı'
                    },
                    color: 'Renk',
                    border: 'Kenarlık',
                    description: 'Açıklama',
                    description_table_place: 'Tablo açıklaması',
                    description_column_place: 'Sütun açıklaması',
                    description_line_place: 'Çizgi açıklaması',
                    description_note_place: 'Not açıklaması',
                    description_area_place: 'Alan açıklaması',
                    description_pen_place: 'Kalem açıklaması',
                    hide_menu: 'Menüyü gizle',
                    show_menu: 'Menüyü göster'
                },
                tab_col: {
                    add_col_below: 'Alta sütun ekle',
                    add_col_above: 'Üste sütun ekle',
                    key: 'Key',
                    keys: {
                        none: 'Yok',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Yok',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Sütunu aşağı taşı',
                    move_col_up: 'Sütunu yukarı taşı',
                    more_functions: 'Diğer işlevler'
                },
                line: {
                    change_connects: 'Bağlayıcıları değiştir',
                    connects: {
                        empty: 'Boş',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Öğeleri filtrele'
                },
                note: {
                    link_placeholder: 'Bağlantı girin',
                    link_apply: 'Ekle',
                    link_remove: 'Kaldır',
                    link_edit: 'Düzenle',
                    link_needs_selection: 'Bağlantı eklemek için metin seçin',
                    bulleted_list: 'Liste',
                    numbered_list: 'Numaralı liste',
                    font_style: 'Yazı tipi stili',
                    alignment: 'Hizalama',
                    align_left: 'Sol',
                    align_center: 'Orta',
                    align_right: 'Sağ',
                    link: 'Bağlantı',
                    monospace: 'Sabit genişlik',
                    bold: 'Kalın',
                    italic: 'İtalik',
                    underline: 'Altı çizili',
                    strikethrough: 'Üstü çizili',
                },
                multi: {
                    filter: 'Seçimi filtrele',
                    create_area: 'Alan oluştur'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Tam',
            keys_only: 'Yalnızca anahtarlar',
            names_only: 'Yalnızca adlar'
        },
        dropdown_ctrl_grid: {
            none: 'Yok',
            lines: 'Çizgiler',
            dots: 'Noktalar',
        },
        dropdown_ctrl_export: {
            export_img: 'Görseli dışa aktar',
            export_code: 'SQL kodunu dışa aktar'
        },
        dropdown_ctrl_settings: {
            back_home: 'Ana sayfaya dön',
            sign_in: 'Giriş yap',
            preferences: 'Tercihler',
            new_project: 'Yeni proje',
            import_diagram: 'Diyagram içe aktar',
            duplicate_diagram: 'Diyagramı çoğalt',
            keyboard_shortcuts: 'Klavye kısayolları',
            languages: 'Diller',
            view: 'Görünüm',
            upgrade_plan: 'Planı yükselt',
            language: 'Dil',
            mouse_trackpad: 'Fare veya trackpad',
            background_color: 'Arka plan rengi',
            grid_layout: 'Izgara düzeni',
            view_mode: 'Görünüm modu',
            show_align_lines: 'Hizalama çizgilerini göster',
            show_members_cursors: 'Üyelerin imleçlerini göster',
            show_comments: 'Yorumları göster',
            undo_redo_controls: 'Geri al/yinele kontrolleri',
            show_scrollbars: 'Kaydırma çubuklarını göster',
            opt_auto: 'Otomatik',
            opt_trackpad: 'Trackpad',
            opt_mouse: 'Fare',
            opt_default: 'Koyu (varsayılan)',
            opt_gray: 'Gri',
            opt_blue: 'Mavi',
            opt_purple: 'Mor',
            opt_violet: 'Menekşe',
            opt_green: 'Yeşil',
            opt_red: 'Kırmızı',
            opt_yellow: 'Sarı',
            opt_dots: 'Noktalar',
            opt_lines: 'Çizgiler',
            opt_none: 'Yok',
            opt_full: 'Tam',
            opt_keys: 'Anahtarlar',
            opt_names: 'Adlar',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Geri bildirim',
            keyboard_shortcuts: 'Klavye kısayolları',
            languages: 'Diller',
            homepage: 'Ana sayfa'
        },
        n: {
            default: 'Yükleniyor…',
            file_ready_to_download: 'Dosya indirmeye hazır',
            code_copied: 'Kod kopyalandı',
            link_copied: 'Bağlantı kopyalandı',
            username_copied: 'Kullanıcı adı panoya kopyalandı',
            email_copied: 'E-posta panoya kopyalandı',
            please_enter_message: 'Lütfen bir mesaj girin',
            invalid_email: 'E-posta geçerli değil',
            note_link_unsupported_protocol: 'Bağlantı türü desteklenmiyor. https, http, mailto kullanın.',
            something_wrong_contact: 'Bir şeyler yanlış gitti. Lütfen sayfayı yeniden yüklemeyi deneyin veya bizimle iletişime geçin.',
            something_wrong: 'Bir şeyler yanlış gitti. Lütfen sayfayı yeniden yüklemeyi deneyin.',
            sending: 'Gönderiliyor…',
            request_sent: 'İstek gönderildi. Teşekkürler!',

            please_enter_email: 'E-posta adresini girin',
            changing: 'Değiştiriliyor...',
            role_changed: 'Rol değiştirildi',
            removing: 'Kaldırılıyor...',
            member_removed: 'Üye kaldırıldı',
            inviting: 'Davet ediliyor...',
            invite_sent: 'Davet gönderildi',
            added_to_diagram: 'Diyagrama eklendi',
            invite_removed: 'Davet kaldırıldı',
            role_not_allowed_on_plan: 'Bu rol planınızda kullanılamıyor. Atamak için yükseltin.',
            already_diagram_member: 'Bu kişinin diyagrama erişimi zaten var.',
            cannot_invite_to_workspace: 'Bu kişiyi davet etmesi için bir çalışma alanı yöneticisinden isteyin.',
            saving: 'Kaydediliyor...',
            saved: 'Kaydedildi',
            diagram_renamed: 'Diyagram yeniden adlandırıldı',
            diagram_updated: 'Diyagram güncellendi',
            duplicating: 'Çoğaltılıyor...',
            diagram_duplicated: 'Diyagram çoğaltıldı',
            deleting: 'Siliniyor...',
            diagram_archived: 'Diyagram arşivlendi',
            diagram_deleted: 'Diyagram silindi',
            restoring: 'Geri yükleniyor...',
            diagram_restored: 'Diyagram geri yüklendi',
            diagram_pinned: 'Diyagram sabitlendi',
            diagram_unpinned: 'Diyagramın sabitlemesi kaldırıldı',
            creating: 'Oluşturuluyor...',
            diagram_created: 'Diyagram oluşturuldu',
            forbidden: 'Buna erişiminiz yok.',
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Zaten çalışma alanı üyesi',
            cannot_invite_self: 'Kendinizi davet edemezsiniz',
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Diyagram bulunamadı.',
            has_diagram_members: 'Diyagramın aktif üyeleri var',
            seat_limit_reached: 'Planınızdaki koltuk sınırına ulaştınız. Daha fazla kişi davet etmek için yükseltin.',
            feature_not_in_plan: 'Bu özellik mevcut planınıza dahil değil.',
            subscription_expired: 'Aboneliğinizin süresi doldu. Kullanmaya devam etmek için yenileyin.',
            subscription_inactive: 'Aboneliğiniz etkin değil. Lütfen fatura bilgilerinizi güncelleyin.',
            plan_limit_generic: 'Planınız bu işleme izin vermiyor. Devam etmek için yükseltin.',

            // Auth / profile
            session_expired: 'Oturumunuzun süresi doldu — lütfen tekrar giriş yapın.',
            profile_updated: 'Profil güncellendi',
            profile_update_failed: 'Profil güncellenemedi.',
            account_delete_failed: 'Hesap silinemedi.',

            // Preferences
            couldnt_save: 'Değişiklikler kaydedilemedi',
            try_again: 'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',

            // Workspace
            not_workspace_member: 'Bu çalışma alanının üyesi değilsiniz.',
            workspace_switch_failed: 'Çalışma alanı değiştirilemedi. Lütfen tekrar deneyin.',
            workspace_create_failed: 'Çalışma alanı oluşturulamadı. Lütfen tekrar deneyin.',
            invalid_workspace_name: 'Geçersiz çalışma alanı adı',
            workspace_updated: 'Çalışma alanı güncellendi',
            workspace_update_failed: 'Çalışma alanı güncellenemedi. Lütfen tekrar deneyin.',
            last_owner_cannot_leave: 'Tek sahip sizsiniz. Ayrılmadan önce başka birini sahip yapın veya çalışma alanını silin.',
            workspace_leave_failed: 'Çalışma alanından ayrılınamadı. Lütfen tekrar deneyin.',
            workspace_delete_forbidden: 'Bu çalışma alanını yalnızca sahibi silebilir.',
            workspace_has_active_billing: 'Silmeden önce bu çalışma alanının aboneliğini iptal edin.',
            workspace_deleted: 'Çalışma alanı silindi',
            workspace_delete_failed: 'Çalışma alanı silinemedi. Lütfen tekrar deneyin.',
            member_remove_forbidden: 'Bu üyeyi kaldırma izniniz yok.',
            member_remove_failed: 'Üye kaldırılamadı. Lütfen tekrar deneyin.',
            cannot_remove_self: 'Kendinizi kaldırmak için "Çalışma alanından ayrıl" seçeneğini kullanın.',
            cannot_remove_last_owner: 'Bir çalışma alanının her zaman bir sahibi olmalıdır. Önce başka birini sahip yapın.',
            invite_revoke_forbidden: 'Bu daveti iptal etme izniniz yok.',
            invite_revoke_failed: 'Davet iptal edilemedi. Lütfen tekrar deneyin.',
        },
        dashboard: {
            doc_title: 'Diyagramlar',
            filter_all: 'Tümü',
            filter_mydiagrams: 'Diyagramlarım',
            filter_shared: 'Benimle paylaşılanlar',
            filter_archived: 'Arşivlenmiş',
            empty_all: '"Tüm diyagramlar" içinde diyagram yok',
            empty_mydiagrams: '"Diyagramlarım" içinde diyagram yok',
            empty_shared: '"Benimle paylaşılanlar" içinde diyagram yok',
            empty_archived: '"Arşivlenmiş" içinde diyagram yok',
            example_diagram_badge: 'Örnek diyagram',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Uygulamaya dön',
                group_personal: 'Kişisel',
                group_organization: 'Organizasyon',
                billing: 'Faturalandırma',
            },
            profile: {
                member_since: '{{date}} tarihinden beri üye',
                general: 'Genel',
                email: 'E-posta',
                full_name: 'Ad soyad',
                full_name_placeholder: 'Adınızı girin',
                account_protection: 'Hesap koruması',
                mfa_label: 'Çok faktörlü kimlik doğrulama (MFA)',
                mfa_sub: 'Hesap için ek güvenlik katmanı · Yakında kullanıma sunulacak',
                mfa_enable: "MFA'yı etkinleştir",
                mfa_soon_tooltip: 'Yakında kullanıma sunulacak',
                workspace_access: 'Çalışma alanı erişimi',
                leave_workspace: 'Çalışma alanından ayrıl',
                leave_workspace_sub: 'Kendinizi çalışma alanından kaldırın',
                leave_owner_tooltip: 'Çalışma alanından ayrılmadan önce sahipliği devredin',
            },
            workspace: {
                header: 'Çalışma alanı',
                general: 'Genel',
                name_label: 'Çalışma alanı adı',
                name_placeholder: 'çalışma alanı adı',
                stat_member_singular: 'Üye',
                stat_member_plural: 'Üyeler',
                stat_team_singular: 'Takım',
                stat_team_plural: 'Takımlar',
                members_section: 'Üyeler',
                no_members: 'Üye yok',
                count_member_singular: 'üye',
                count_member_plural: 'üye',
                view_members_btn: 'Üyeleri görüntüle',
                danger_zone: 'Tehlikeli bölge',
                delete_workspace: 'Çalışma alanını sil',
                delete_workspace_sub: 'Bu, çalışma alanını kalıcı olarak silecektir',
                delete_owner_only_tooltip: 'Yalnızca sahipler çalışma alanlarını silebilir',
                delete_cancel_sub_tooltip: 'Çalışma alanını silmeden önce aboneliğinizi iptal edin',
            },
            members: {
                header: 'Üyeler',
                col_name: 'Ad',
                col_email: 'E-posta',
                col_role: 'Rol',
                col_joined: 'Katıldı',
                active_members: 'Aktif üyeler',
                invited_section: 'Davet edildi',
                no_members: 'Henüz üye yok.',
                options_aria: 'Seçenekler',
                leave_workspace_item: 'Çalışma alanından ayrıl...',
                remove_member_item: 'Üyeyi kaldır...',
                remove_owner_only_tooltip: 'Yalnızca sahipler üyeleri kaldırabilir',
                remove_owner_row_tooltip: 'Sahip, çalışma alanından kaldırılamaz',
                remove_invite_item: 'Daveti kaldır...',
                role_invited_suffix: '{{role}} (Davet edildi)',
            },
            preferences: {
                section_general: 'Genel',
                section_diagram_defaults: 'Diyagram ayarları',
                section_diagram_views: 'Diyagram görünümleri',
                section_notifications: 'Bildirimler',
                theme_label: 'Arayüz teması',
                theme_sub: 'Arayüz renk şemanızı seçin',
                theme_dark: 'Koyu',
                theme_light: 'Açık',
                theme_system: 'Sistem',
                language_sub: 'Arayüz dilinizi seçin',
                timezone_label: 'Saat dilimi',
                timezone_sub: 'Saat diliminizi seçin',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaii',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Pasifik Saati',
                    denver: 'GMT-07:00 — Dağ Saati',
                    chicago: 'GMT-06:00 — Merkez Saati',
                    new_york: 'GMT-05:00 — Doğu Saati',
                    caracas: 'GMT-04:00 — Karakas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Azorlar',
                    london: 'GMT+00:00 — Londra',
                    paris: 'GMT+01:00 — Paris, Berlin',
                    kyiv: 'GMT+02:00 — Kyiv, Atina',
                    istanbul: 'GMT+03:00 — İstanbul',
                    dubai: 'GMT+04:00 — Dubai',
                    karachi: 'GMT+05:00 — Karaçi',
                    kolkata: 'GMT+05:30 — Hindistan',
                    dhaka: 'GMT+06:00 — Dakka',
                    bangkok: 'GMT+07:00 — Bangkok, Cakarta',
                    shanghai: 'GMT+08:00 — Pekin, Singapur',
                    tokyo: 'GMT+09:00 — Tokyo, Seul',
                    sydney: 'GMT+10:00 — Sidney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Tuval gezinme kontrollerini seçin',
                background_sub: 'Tuval için bir arka plan rengi seçin',
                grid_sub: 'Tuval ızgara düzenini seçin',
                show_align_lines_sub: 'Nesneleri hizalarken çizgileri göster',
                show_cursors_sub: 'Diğer çalışanların imleçlerini göster',
                show_comments_sub: 'Tuval üzerinde yorumları göster',
                show_scrollbars_sub: 'Tuvalde gezinirken kaydırma çubuklarını göster',
                show_undo_redo_label: 'Geri al/yinele kontrollerini göster',
                show_undo_redo_sub: 'Değişiklikleri geri almak ve yinelemek için kontrolleri göster',
                notif_shared_label: 'Benimle paylaşılan diyagram',
                notif_shared_sub: 'Biri benimle bir diyagram paylaştığında',
                notif_mentions_label: 'Yorumlardaki bahsetmeler',
                notif_mentions_sub: 'Biri bir yorumda beni @bahsettiğinde',
                notif_updates_label: 'Ürün güncellemeleri',
                notif_updates_sub: 'Yeni özellikler ve iyileştirmeler hakkında aylık güncellemeler',
                show: 'Göster',
                hide: 'Gizle',
                on: 'Açık',
                off: 'Kapalı',
            },
            billing: {
                header: 'Faturalandırma',
                plan_free: 'Ücretsiz plan',
                status_current: 'Güncel',
                no_renewal_needed: 'Yenileme gerekmiyor',
                payment_header: 'Ödeme',
                no_payments: 'Ödeme yok',
                invoices_header: 'Faturalar',
                no_invoices: 'Fatura yok',
            },
            usage: {
                doc_title: 'Kullanım',
                overview_title: 'Genel bakış',
                resource_limits_title: 'Kaynak sınırları',
                label_diagrams: 'Diyagramlar',
                label_tables: 'Tablolar',
                label_areas: 'Alanlar',
                label_notes: 'Yapışkan notlar',
                label_members: 'Üyeler',
                label_tables_per_diagram: 'Tablo / Diyagram',
                label_areas_per_diagram: 'Alan / Diyagram',
                label_notes_per_diagram: 'Not / Diyagram',
                need_more_title: 'Daha fazlasına mı ihtiyacınız var?',
                need_more_free: 'Daha fazla diyagram, sürüm geçmişi ve öncelikli destek için Basic plana yükseltin.',
                need_more_paid: 'Sınırsız diyagram, koltuk ve gelişmiş özellikler için Professional plana yükseltin.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Sayfa bulunamadı',
                dont_have_access_to_diagram: 'Bu diyagrama erişiminiz yok veya artık mevcut olmayabilir.',
                back_home: 'Ana sayfaya dön'
            },
            error: {
                title: 'Hata',
                link_is_invalid: 'Bu bağlantı geçersiz veya yanlış girilmiş.',
                something_wrong: 'Bir şeyler yanlış gitti.',
                back_home: 'Ana sayfaya dön',
                please_try_later: 'Lütfen daha sonra tekrar deneyin',
            },
            billing_success: {
                doc_title: 'Plan yükseltildi',
                heading: 'Ödeme başarılı',
                subtitle: 'Planınız başarıyla yükseltildi.',
                cta: 'Tasarlamaya başla',
            },
            email_verified: {
                doc_title: 'E-posta doğrulandı',
            },
            forgot_password: {
                doc_title: 'Şifremi unuttum',
            },
            password_updated: {
                doc_title: 'Şifre güncellendi',
            },
            reset_password: {
                doc_title: 'Şifreyi sıfırla',
            },
            check_email: {
                doc_title: 'E-postanızı kontrol edin',
            },
            sign_in: {
                doc_title: '{{product}}’e giriş yap',
            },
            sign_up: {
                doc_title: '{{product}}’e kaydol',
            },
        },
    }
};

export const trMeta = {
    lang_origin: 'Türkçe',
    lang_eng: 'Turkish',
    lang_code: 'tr',
};
